/**
 * デバイス判定とPWAインストール状態を検出するヘルパー関数
 */

/**
 * iOSデバイスかどうかを判定
 * @returns {boolean} iOSデバイスの場合はtrue
 */
export const isIOS = () => {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
};

/**
 * iOS Safariかどうかを判定
 * @returns {boolean} iOS Safariの場合はtrue
 */
export const isIOSSafari = () => {
  const ua = navigator.userAgent;
  const iOS = /iPhone|iPad|iPod/.test(ua);
  const webkit = /WebKit/.test(ua);
  const isSafari = iOS && webkit && !/CriOS|FxiOS|OPiOS|mercury/.test(ua);
  return isSafari;
};

/**
 * PWAとしてインストールされているか（スタンドアロンモードか）を判定
 * @returns {boolean} PWAとしてインストールされている場合はtrue
 */
export const isPWAInstalled = () => {
  // display-mode: standaloneをチェック
  if (window.matchMedia('(display-mode: standalone)').matches) {
    return true;
  }

  // iOS Safariの古い方式もチェック
  if (window.navigator.standalone === true) {
    return true;
  }

  return false;
};

/**
 * Web Push通知がサポートされているかを判定
 * @returns {boolean} Web Push通知がサポートされている場合はtrue
 */
export const isWebPushSupported = () => {
  return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
};

/**
 * 通知許可状態を取得
 * @returns {string} 'granted' | 'denied' | 'default'
 */
export const getNotificationPermission = () => {
  if (!('Notification' in window)) {
    return 'unsupported';
  }
  return Notification.permission;
};

/**
 * iOS PWAでWeb Push通知が利用可能かを判定
 * iOS 16.4以降のPWAで通知が利用可能
 * @returns {boolean} 利用可能な場合はtrue
 */
export const isIOSPWAPushAvailable = () => {
  return isIOS() && isPWAInstalled() && isWebPushSupported();
};

/**
 * デバイス情報をデバッグ用にコンソールに出力
 */
export const logDeviceInfo = () => {
  console.log('[Device Info]', {
    userAgent: navigator.userAgent,
    isIOS: isIOS(),
    isIOSSafari: isIOSSafari(),
    isPWAInstalled: isPWAInstalled(),
    isWebPushSupported: isWebPushSupported(),
    notificationPermission: getNotificationPermission(),
    isIOSPWAPushAvailable: isIOSPWAPushAvailable(),
    displayMode: window.matchMedia('(display-mode: standalone)').matches ? 'standalone' : 'browser',
    navigatorStandalone: window.navigator.standalone,
  });
};
